import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MyDataInitializer  {
    _originalTypeClassName = "zERP.BO.MyDataInitializer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MyDataInitializer.translate = translateService;
}
this.MyDataInitializerKey = null;
this._key = this.MyDataInitializerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _MyDataInitializerKey:any;
get MyDataInitializerKey(): any {
    return this._MyDataInitializerKey;
  }
set MyDataInitializerKey(value: any) {
    this._MyDataInitializerKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MyDataInitializerKey == null || $this.MyDataInitializerKey == 0;
            }


}